// components/LoopBackEdge.tsx
import {   getSmoothStepPath } from '@xyflow/react';

export const LoopBackEdge = ({ id, sourceX, sourceY, targetX, targetY, source, target, data }: any) => {
  const [edgePath,  ] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    borderRadius: 50 // Higher curve for visual distinction
  });

  return (
    <>
      {/* Marker definition for yellow arrow */}
      <svg style={{ height: 0 }}>
        <defs>
          <marker
            id="loopback-arrow"
            markerWidth="18"
            markerHeight="6"
            viewBox="0 0 10 8"
            refX="10"
            refY="4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 4 L 0 8 z" fill="#ff9800" />
          </marker>
        </defs>
      </svg>

      {/* Edge path with arrow marker */}
      <path
        id={id}
        d={edgePath}
        className="react-flow__edge-path loopback"
        style={{ 
          stroke: '#ff9800', // Orange color for distinction
          strokeWidth: 2
        }}
        fill="none"
        markerEnd="url(#loopback-arrow)"
      />
      
      {/* Edge label
      <EdgeLabelRenderer>
        <div
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            fontSize: 12,
            background: '#fff',
            padding: '2px 6px',
            borderRadius: 4,
            border: '1px solid #ff9800',
            color: '#ff9800',
            fontWeight: 600,
            userSelect: 'none',
            zIndex: 10,
            pointerEvents: 'none' // No interaction
          }}
        >
          ↻ Loop
        </div>
      </EdgeLabelRenderer> */}
    </>
  );
};
